let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6TmB4")).then(() => parcelRequire('ly6Vc'));